import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "game-view" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "game-header" }
const _hoisted_4 = { class: "mode-display" }
const _hoisted_5 = {
  key: 0,
  class: "track-loaded-indicator"
}
const _hoisted_6 = { class: "game-content" }
const _hoisted_7 = {
  key: 0,
  class: "scan-prompt"
}
const _hoisted_8 = {
  key: 1,
  class: "track-ready"
}
const _hoisted_9 = { class: "game-actions" }
const _hoisted_10 = {
  key: 0,
  class: "error-banner"
}
const _hoisted_11 = {
  key: 1,
  class: "loading-overlay"
}

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGameState } from '@/composables/useGameState';
import SpotifyStatusBadge from '@/components/Spotify/SpotifyStatusBadge.vue';
import QRScanner from '@/components/Game/QRScanner.vue';
import PlaybackControls from '@/components/Game/PlaybackControls.vue';
import PrimaryButton from '@/components/UI/PrimaryButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GameView',
  setup(__props) {

const router = useRouter();
const scannerOpen = ref(false);

const {
  mode,
  currentTrackUri,
  currentTrackMeta,
  isPlaying,
  hasUserPressedPlayButton,
  isLoading,
  error,
  canPlay,
  handleScan: handleGameScan,
  play,
  pause,
  reset
} = useGameState();

function openScanner() {
  scannerOpen.value = true;
}

function closeScanner() {
  scannerOpen.value = false;
}

async function handleScan(qrValue: string) {
  await handleGameScan(qrValue);

  // Nur Scanner schließen – Abspielen übernimmt der Play-Button
  scannerOpen.value = false;
}



function handlePlay() {
  play();
}

function handlePause() {
  pause();
}

function scanNewCard() {
  reset();
  openScanner();
}

function goHome() {
  reset();
  router.push('/');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SpotifyStatusBadge)
        ]),
        (_unref(currentTrackMeta))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "indicator-dot" }, null, -1),
              _createElementVNode("span", { class: "indicator-text" }, "Karte geladen", -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_unref(currentTrackUri))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "scan-icon" }, "📷", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Bereit zum Scannen", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Scanne den QR-Code auf deiner Spielkarte", -1)),
              _createVNode(PrimaryButton, {
                size: "lg",
                onClick: openScanner
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Karte scannen ", -1)
                ]))]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-visual" }, [
                _createElementVNode("div", { class: "card-icon" }, "🎵"),
                _createElementVNode("p", { class: "card-hint" }, "Song bereit!")
              ], -1)),
              _createVNode(PlaybackControls, {
                mode: _unref(mode),
                "is-playing": _unref(isPlaying),
                "can-play": _unref(canPlay),
                "has-user-pressed-play-button": _unref(hasUserPressedPlayButton),
                onPlay: handlePlay,
                onPause: handlePause
              }, null, 8, ["mode", "is-playing", "can-play", "has-user-pressed-play-button"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_unref(currentTrackUri))
          ? (_openBlock(), _createBlock(PrimaryButton, {
              key: 0,
              variant: "secondary",
              size: "md",
              "full-width": "",
              onClick: scanNewCard
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Neue Karte scannen ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(PrimaryButton, {
          variant: "ghost",
          size: "sm",
          "full-width": "",
          onClick: goHome
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Zurück zum Hauptmenü ", -1)
          ]))]),
          _: 1
        })
      ]),
      (_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", null, "⚠️ " + _toDisplayString(_unref(error)), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("div", { class: "loading-spinner" }, null, -1),
            _createElementVNode("p", null, "Lade Track...", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(QRScanner, {
      "is-open": scannerOpen.value,
      onScanned: handleScan,
      onClose: closeScanner
    }, null, 8, ["is-open"])
  ]))
}
}

})